module.exports = __webpack_public_path__ + "static/image/history/pc/201403@3x.jpg?5886c4c8";